import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginNoCaptchaModuleComponent } from './login-no-captcha.component';

const routes: Routes = [
  {
    path: '',
    component: LoginNoCaptchaModuleComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginNoCaptchaRoutingModule {}
